import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, Inject, } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-enrichment-themes-dialog',
  templateUrl: './enrichment-themes-dialog.component.html',
  styleUrls: ['./enrichment-themes-dialog.component.scss']
})
export class EnrichmentThemesDialogComponent {
  titleClass: string;
  themeName: string;
  dogNames: string;
  themeSubHeader: string;
  themeUrl: string;
  logoImage = './../../assets/images/bddc-bouncer-logo.png';
  placeholderImage = './../../assets/images/backgrounds/desktop_bg.jpg'

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>, private overlayContainer: OverlayContainer, public breakpointObserver: BreakpointObserver) {
    overlayContainer.getContainerElement().classList.add('enrichment-theme-dialog-overlay');
    overlayContainer.getContainerElement().classList.remove('mini-calendar-dialog_overlay');
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.Tablet
    ]).subscribe(result => {
      if (result.matches) {
        this.setMobileLayout();
      } else {
        this.setDesktopLayout();
      }
    });

    this.themeName = this.data.themeName;
    this.dogNames = this.data.dogNames;
    this.themeSubHeader = this.data.subHeader;
    this.themeUrl = this.data.image == null ? this.placeholderImage : this.data.image;
  }

  ngOnDestroy() {
    this.overlayContainer.getContainerElement().classList.remove('enrichment-theme-dialog-overlay');
  }

  setMobileLayout() {
    if (window.innerWidth > 830 && window.innerWidth < 1360) {
      this.dialogRef.updateSize('500px', '475px');
    } else {
      this.dialogRef.updateSize('343px', '375px');
    }
  }

  setDesktopLayout() {
    this.dialogRef.updateSize('600px', '600px');
  }
}
